<template>
  <div class="detail-container">
    <detail :data="detailData" :checkState="checkState" :date="date"></detail>
  </div>
</template>

<script>
import detail from "./components/detail";
import { getDetailMgr } from "common/js/api";

export default {
  components: {
    detail,
  },

  data() {
    return {
      institutionCode: this.$route.query.institutionCode,
      detailData: {},
      checkState: "",
      date:"",
    };
  },
  created() {
    this.getCheckState();
  },
  mounted() {
    this.getDetail();
  },

  methods: {
    async getDetail() {
      const res = await getDetailMgr(this.institutionCode);
      this.detailData = res.result;
      this.detailData.basic.associationRegiste = this.detailData.basic.associationRegiste?'1':'0';
      this.detailData.basic.associationRegisteFinished = this.detailData.basic.associationRegisteFinished?'1':'0';
      this.detailData.basic.clusterRegiste = this.detailData.basic.clusterRegiste?'1':'0';
      console.log("FundDetail组件--查到后台数据", this.detailData);
      const arr = this.detailData.basic.preIndustry;
      this.detailData.basic.preIndustry = arr.toString().split(",");
      
    },
    getCheckState() {
      this.checkState = this.$route.query.checkState;
      this.date = this.$route.query.date.substring(0,10);
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-container {
  padding: 20px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 12px 0px #cccccc80;
}
</style>

